import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom'
import { SelectProvinceList } from '../OfflineDb/IndexDbTranscSP'
import AlertModal from '../CommonControlls/AlertModal'
import { SyncConfig } from '../OfflineDb/ConfigDataSync'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import DropDown from '../CommonControlls/DropdownRendrer'

const mapStateToProps = (store) => {
  return store
}

const mapDispatchToProps = (dispatch) => {
  return {
    ShowAlert: (Settings) => {
      dispatch({ type: 'UpdateAlert', payload: Settings })
    },
    ShowLoader: (Isloading) => {
      dispatch({ type: 'UpdateLoader', payload: Isloading })
    },
  }
}

class Province_List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // Table
      data: [],
      page: 1,
      sizePerPage: 15,
      TotalRecord: 0,
      loading: false,
      exportLoading: false,

      sortField: 'id',
      idsortOrder: 'desc',
      namesortOrder: '',

      SrList: [],
      SrId: [],
      FilteredSrs: [],
      permissions: [],

      alertModalData: {
        title: '',
        message: '',
        First_Callback: () => {},
        Second_Callback: () => {},
        type: 1,
      },
    }
  }
  HandleAutoSuggestValChange = (fieldId, value) => {
    this.setState({
      [fieldId]: value,
      // isSaveSearch: this.state.isSearchChanged ? true : false
    })
  }

  ExportPdf = () => {
    const doc = new jsPDF()

    doc.autoTable({
      theme: 'grid',
      body: [...this.state.data],
      columns: [
        { header: 'id', dataKey: 'id' },
        { header: 'Name', dataKey: 'name' },
      ],
    })

    doc.save('province.pdf')
  }

  componentWillMount() {
    if (this.props.UserAuthentication.AuthToken === '') {
      this.props.history.push('/Login')
    }
  }

  componentDidMount() {
    Common.AddClassToMenueLink(
      'MenuLink_Province',
      true,
      'MenuParentLink_Geography',
    )
    // Common.AddClassToMenueLink("MenuLink_Province")
    this.PopulateTable()
    $('.Search_InputField').on('keypress', (e) => {
      if (e.which === 13) {
        this.PopulateTable()
      }
    })

    this.SelectSubReciepents()

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.SelectAll_RolesPermissions,
      {
        pageSize: 15,
        pageNumber: 1,
      },
      (resp) => {
        const modifiedPermissions = resp.data
          .filter(
            (p) => p.permissioN_GROUP === 'Geography' && p.permissioN_ALLOWED,
          )
          .map((d) => d.permissioN_NAME)
        this.setState({ permissions: modifiedPermissions })
      },
    )
  }

  handleTableChange = (
    type,
    { page, sizePerPage, filters, sortField, sortOrder, cellEdit },
  ) => {
    if (type === 'sort') {
      let tempFieldorderLabel = sortField + 'sortOrder'
      let tempFieldorder =
        this.state[tempFieldorderLabel] === ''
          ? sortOrder
          : this.state[tempFieldorderLabel] === 'asc'
          ? 'desc'
          : 'asc'
      this.setState(
        {
          sortField,
          [tempFieldorderLabel]: tempFieldorder,
        },
        () => {
          this.PopulateTable()
        },
      )
      return
      // let result = this.state.data
      // // Handle column sort
      // if (sortOrder === 'asc') {
      //     result = result.sort((a, b) => {
      //     if (a[sortField] > b[sortField]) {
      //         return 1;
      //     } else if (b[sortField] > a[sortField]) {
      //         return -1;
      //     }
      //     return 0;
      //     });
      // } else {
      //     result = result.sort((a, b) => {
      //     if (a[sortField] > b[sortField]) {
      //         return -1;
      //     } else if (b[sortField] > a[sortField]) {
      //         return 1;
      //     }
      //     return 0;
      //     });
      // }
      // return
    }
    this.setState(
      {
        page,
        sizePerPage,
      },
      () => {
        this.PopulateTable()
      },
    )
  }

  ExportData = (size) => {
    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ loading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuhtToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Province,
      { pageSize: size, pageNumber: 1 },
      (resp) => {
        let data = resp.data
        // Sort
        if (this.state[this.state.sortField + 'sortOrder'] === 'asc') {
          data = data.sort((a, b) => {
            if (a[this.state.sortField] > b[this.state.sortField]) {
              return 1
            } else if (b[this.state.sortField] > a[this.state.sortField]) {
              return -1
            }
            return 0
          })
        } else {
          data = data.sort((a, b) => {
            if (a[this.state.sortField] > b[this.state.sortField]) {
              return -1
            } else if (b[this.state.sortField] > a[this.state.sortField]) {
              return 1
            }
            return 0
          })
        }

        // Paginate
        var TotalRecord = data.length
        var paginatedData = Common.paginate(
          data,
          this.state.sizePerPage,
          this.state.page,
        )

        $('#FormSearchBtn').prop('disabled', false)
        this.setState({
          data: data,
          TotalRecord,
          exportLoading: false,
        })
        $('.react-bs-table-csv-btn').click()
        this.PopulateTable()
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }

  SelectSubReciepents = () => {
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectALl_SubRecipient,
      {},
      (resp) => {
        if (resp.status) {
          this.setState({
            SrList: resp.data.map((d) => ({ id: d.id, name: d.short_name })),
          })
        }
      },
    )
  }

  PopulateTable = () => {
    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ loading: true })
    var srIdString =
      this.state.SrId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.SrId, 'id') + ','
    const Parameters = {
      pageSize: this.state.sizePerPage,
      subrecipientId: srIdString,
      pageNumber: this.state.page,
      name: $('#SearchName').val(),
    }
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Province,
      Parameters,
      (resp) => {
        let data = resp.data
        // Sort
        if (this.state[this.state.sortField + 'sortOrder'] === 'asc') {
          data = data.sort((a, b) => {
            if (a[this.state.sortField] > b[this.state.sortField]) {
              return 1
            } else if (b[this.state.sortField] > a[this.state.sortField]) {
              return -1
            }
            return 0
          })
        } else {
          data = data.sort((a, b) => {
            if (a[this.state.sortField] > b[this.state.sortField]) {
              return -1
            } else if (b[this.state.sortField] > a[this.state.sortField]) {
              return 1
            }
            return 0
          })
        }

        // Paginate
        var TotalRecord = data.length
        var paginatedData = Common.paginate(
          data,
          this.state.sizePerPage,
          this.state.page,
        )

        $('#FormSearchBtn').prop('disabled', false)
        this.setState({
          data: paginatedData,
          TotalRecord: TotalRecord,
          loading: false,
        })
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  onDelete = (id) => {
    this.setState(
      {
        alertModalData: {
          title: 'Delete Province',
          message: 'Are you sure you want to delete this record.',
          First_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
            this.DeleteRecord(id)
          },
          Second_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
          },
          type: 1,
        },
      },
      () => {
        $('#Show_ArletModal').click()
      },
    )
  }
  DeleteRecord = (id) => {
    this.props.ShowLoader({ Isloading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.Delete_Province,
      { id: id },
      (Result) => {
        if (Result.status == true) {
          SyncConfig(
            () => {
              this.PopulateTable()
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({ Type: 1, Msg: 'Deleted Successfully.' })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
            () => {
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({
                Type: 0,
                Msg: 'Error in sync, please reload the page',
              })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
          )
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: Result.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }

  render() {
    const CellMenu = (cell, row) => {
      return (
        <div>
          {this.state.permissions.includes('province-update') && (
            <Link to={'/Province_Edit/' + row.id}>
              <button
                data-toggle="tooltip"
                title="Edit"
                class="btn TableRow_btn"
              >
                <i
                  class="fa fa-pencil-square-o text-primary"
                  aria-hidden="true"
                ></i>
              </button>
            </Link>
          )}
          {this.state.permissions.includes('province-delete') && (
            <button
              onClick={() => this.onDelete(row.id)}
              data-toggle="tooltip"
              title="Delete"
              class="btn TableRow_btn"
            >
              <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
            </button>
          )}
        </div>
      )
    }

    const columns = [
      {
        dataField: 'name',
        text: 'Province Name',
        sort: true,
      },
      {
        dataField: 'short_name',
        text: 'SR. Name',
        sort: true,
        hidden:true,
      },
      {
        dataField: '',
        text: 'Actions',
        headerStyle: (colum, colIndex) => {
          return { width: '120px' }
        },
        formatter: (cell, row) => {
          return CellMenu(cell, row)
        },
        csvExport: false,
      },
    ]

    return (
      <>
        <AlertModal {...this.state.alertModalData} />
        <MainLayout />
        <div id="right-panel" class="right-panel">
          <Topmenu
            PageTitle="Province"
            isShowAddBtn={this.state.permissions.includes('province-add')}
            AddBtnLabel="Add Province"
            AddBtnLink="/Province_Add"
          />
          <div class="content">
            <div class="card">
              <div class="card-body">
                <div class="Table_Search row">
                  <div class="formInput_Container col-lg-3 col-md-4 col-sm-12 col-xs-12">
                    <label for="">Province Name</label>
                    <input
                      autocomplete="off"
                      type="text"
                      class="form-control Search_InputField"
                      id="SearchName"
                      placeholder="Enter province name"
                    />
                  </div>

                  <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="">Sub Recipient</label>
                    <DropDown
                      multi={true}
                      dropdownRenderer={true}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="SrId"
                      options={this.state.SrList}
                      val={this.state.SrId}
                      addPlaceholder=""
                      disabled={false}
                      loading={false}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={true}
                      placeholder="Select"
                    />
                  </div>

                  <div class="formInput_Container col-lg-3 col-md-4 col-sm-12 col-xs-12">
                    <button
                      style={{ position: 'relative', marginTop: 36 }}
                      onClick={() => {
                        this.PopulateTable()
                      }}
                      id="FormSearchBtn"
                      class="btn SearchTable_Btn"
                    >
                      Search
                    </button>
                  </div>
                </div>
                <Table
                  keyField="id"
                  data={this.state.data}
                  page={this.state.page}
                  sizePerPage={this.state.sizePerPage}
                  totalSize={this.state.TotalRecord}
                  exportPdf={this.ExportPdf}
                  changeSizePerPage={(size) => {
                    setTimeout(() => {
                      this.setState({
                        exportLoading: true,
                      })
                      this.ExportData(size)
                    }, 100)
                  }}
                  exportAllowed={this.state.permissions.includes(
                    'province-export',
                  )}
                  onTableChange={this.handleTableChange}
                  isPagination={true}
                  columns={columns}
                  loading={this.state.loading}
                  RefreshTable={this.PopulateTable}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Province_List)
